import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBashgahNameLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    data-name='Layer 2'
    viewBox='0 0 1440.24 982.89'
    {...props}
  >
    <defs>
      <pattern
        id='bashgah-name-logo_svg__a'
        width={72}
        height={72}
        x={0}
        y={0}
        data-name='6 lpi 40%'
        patternTransform='rotate(-45 -2771.81 -17644.159)scale(1.8)'
        patternUnits='userSpaceOnUse'
      >
        <path
          d='M0 0h72v72H0z'
          style={{
            fill: 'none',
            strokeWidth: 0,
          }}
        />
        <path
          d='M71.75 66h72.5M71.75 42h72.5M71.75 18h72.5M71.75 54h72.5M71.75 30h72.5M71.75 6h72.5M-.25 66h72.5M-.25 42h72.5M-.25 18h72.5M-.25 54h72.5M-.25 30h72.5M-.25 6h72.5M-72.25 66H.25M-72.25 42H.25M-72.25 18H.25M-72.25 54H.25M-72.25 30H.25M-72.25 6H.25'
          style={{
            fill: 'none',
            stroke: '#5cc8ff',
            strokeWidth: '4.8px',
          }}
        />
      </pattern>
      <pattern
        xlinkHref='#bashgah-name-logo_svg__a'
        id='bashgah-name-logo_svg__b'
        data-name='6 lpi 40%'
        patternTransform='rotate(-45 -2776.083 -17645.929)scale(1.8)'
      />
      <pattern
        xlinkHref='#bashgah-name-logo_svg__a'
        id='bashgah-name-logo_svg__c'
        data-name='6 lpi 40%'
        patternTransform='rotate(-45 -2776.083 -17645.929)scale(1.8)'
      />
      <pattern
        xlinkHref='#bashgah-name-logo_svg__a'
        id='bashgah-name-logo_svg__d'
        data-name='6 lpi 40%'
        patternTransform='rotate(-45 -2776.083 -17645.929)scale(1.8)'
      />
      <pattern
        xlinkHref='#bashgah-name-logo_svg__a'
        id='bashgah-name-logo_svg__e'
        data-name='6 lpi 40%'
        patternTransform='rotate(-45 -2776.083 -17645.929)scale(1.8)'
      />
      <pattern
        xlinkHref='#bashgah-name-logo_svg__a'
        id='bashgah-name-logo_svg__f'
        data-name='6 lpi 40%'
        patternTransform='rotate(-45 -2916.95 -17585.95)scale(1.8)'
      />
      <pattern
        xlinkHref='#bashgah-name-logo_svg__a'
        id='bashgah-name-logo_svg__g'
        data-name='6 lpi 40%'
        patternTransform='rotate(-45 -2872.363 -17700.418)scale(1.8)'
      />
    </defs>
    <path
      d='M80.9 590.75v72.76h85.91v74.79c0 7.25-5.88 13.13-13.13 13.13H80.46v-82.86H1V825.2h190.55c30.97 0 56.08-25.11 56.08-56.08V590.76H80.9Z'
      style={{
        fill: '#004d76',
        strokeWidth: 0,
      }}
    />
    <path
      d='M1083.4 668.56v80.34h-32.84v-80.34H967.4v80.34h-32.84v-80.34H853.4v80.34h-74.97v76.29h326.4c35.16 0 63.66-28.5 63.66-63.66v-92.97z'
      style={{
        fill: 'url(#bashgah-name-logo_svg__a)',
        strokeWidth: 0,
      }}
    />
    <path
      d='M611.75 502.33H736.8L560.27 615.47c-5.78 3.71-3.16 12.67 3.71 12.67h163.74c33.08 0 59.89 26.81 59.89 59.89v137.16H346.1c-27 0-48.88-21.89-48.88-48.88V600.98c0-6.43-5.06-11.71-11.48-11.99l-5.95-.26v-86.4h98.53v240.25c0 4.6 3.73 8.34 8.34 8.34h319.07v-32.97c0-9.42-7.63-17.05-17.05-17.05H427.59v-80.34l184.17-118.23Z'
      style={{
        fill: '#004d76',
        strokeWidth: 0,
      }}
    />
    <path
      d='M518.56 503.09h65.93L426.85 606.92v-43.2z'
      style={{
        fill: '#004d76',
        strokeWidth: 0,
      }}
    />
    <path
      d='m1373.73 922.29-56.27 56.27-56.27-56.27 56.27-56.27z'
      style={{
        fill: 'url(#bashgah-name-logo_svg__b)',
        strokeWidth: 0,
      }}
    />
    <path
      d='m1060.77 475.33-56.27 56.27-56.27-56.27 56.27-56.27z'
      style={{
        fill: 'url(#bashgah-name-logo_svg__c)',
        strokeWidth: 0,
      }}
    />
    <path
      d='M1353.67 665.02v81.85H1265v78.32h121.64c26.58 0 48.13-21.55 48.13-48.13V665.02h-81.09Z'
      style={{
        fill: 'url(#bashgah-name-logo_svg__d)',
        strokeWidth: 0,
      }}
    />
    <path
      d='M1241.45 105.47c-137.64-39.15-201.74 28.05-201.74 28.05l-1.05-98.05H0v524.86l95.35-94.35c10.24-10.13 26.23-11.54 38.08-3.36l33.38 23.04 41.6-37.44a24.73 24.73 0 0 1 25.75-4.58l.86.34 26.9-20.57a24.61 24.61 0 0 1 25.2-2.82l4.74 2.17 6.09-4.98a20.25 20.25 0 0 1 22.57-2.07l3.17 1.75 87.93-88.51a30.46 30.46 0 0 1 34.72-6.03l26.65 12.69 26.38-24.59a42.19 42.19 0 0 1 42.11-9.16l17.68 5.89c13.16 4.39 25.35 11.3 35.87 20.34l68.32 58.71c10.18 8.74 25.38 8.14 34.84-1.37l130.43-131.3c11.16-10.86 28.66-11.72 40.84-2.02l30.99 29.7 148.17-137.94s108.76 147.03 135.28 159.92c26.53 12.88 73.52 35.62 105.35 73.52 21.03 25.04 50.01 53.72 67.25 70.3 7.86 7.56 20.46 6.89 27.49-1.43l56.24-66.59V99.2c-7.71 6.49-61.32 45.37-198.79 6.27Z'
      style={{
        fill: 'url(#bashgah-name-logo_svg__e)',
        strokeWidth: 0,
      }}
    />
    <path
      d='m1015.14 565.33-56.27 56.27-56.27-56.27 56.27-56.27z'
      style={{
        fill: 'url(#bashgah-name-logo_svg__f)',
        strokeWidth: 0,
      }}
    />
    <path
      d='m1109.14 563.33-56.27 56.27-56.27-56.27 56.27-56.27z'
      style={{
        fill: 'url(#bashgah-name-logo_svg__g)',
        strokeWidth: 0,
      }}
    />
    <path
      d='M1192.24 582.67v-77.31h93.22v319.83h-29.94c-27.84 0-50.4-22.56-50.4-50.4V595.55c0-7.12-5.77-12.88-12.88-12.88M1440.24 89.01s-53.3 49.81-195.81 8c-132.52-38.88-195.81 17-195.81 17V38.26s46.11-55.84 195.81-21.48c157.76 36.21 195.81-14.52 195.81-14.52v86.76Z'
      style={{
        fill: '#004d76',
        strokeWidth: 0,
      }}
    />
  </svg>
);
export default SvgBashgahNameLogo;
